export const module = {
  info: {
    name: 'user-side-menu',
    caption: 'user side menu',
    viewGroup: 'general-modules'
  },
  vuexModules: [],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    caption: 'Panel Users',
    icon: 'el-icon-user',
    routeName: 'module->user->panel',
    children: [
      {
        caption: 'Create User',
        icon: 'el-icon-plus',
        routeName: 'module->user->create'
      },
      {
        caption: 'List Users',
        icon: 'el-icon-more-outline',
        routeName: 'module->user->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
